import { render, staticRenderFns } from "./VacationRequest.vue?vue&type=template&id=ebc01f78&scoped=true&"
import script from "./VacationRequest.vue?vue&type=script&lang=js&"
export * from "./VacationRequest.vue?vue&type=script&lang=js&"
import style0 from "./VacationRequest.vue?vue&type=style&index=0&id=ebc01f78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc01f78",
  null
  
)

export default component.exports